var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`tab-container ${_vm.customClass}`},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:tab[_vm.propsMap.key],class:`tab-item ${tab[_vm.propsMap.key] === _vm.value ? 'active' : ''} ${_vm.disabled ? 'disabled' : ''}`,style:({
    borderTopLeftRadius: _vm.showRadius && index === 0 ? '8px' : '0px',
    borderBottomLeftRadius: _vm.showRadius && index === 0 ? '8px' : '0px',
    borderTopRightRadius: _vm.showRadius && index === _vm.tabs.length - 1 ? '8px' : '0px',
    borderBottomRightRadius: _vm.showRadius && index === _vm.tabs.length - 1 ? '8px' : '0px',
    borderTop: _vm.showBorder ? `1px solid ${_vm.borderColor}` : 'none',
    borderBottom: _vm.showBorder ? `1px solid ${_vm.borderColor}` : 'none',
    borderRight: _vm.showBorder ? `1px solid ${_vm.borderColor}` : 'none',
    borderLeft: _vm.showBorder && index === 0 ? `1px solid ${_vm.borderColor}` : 'none',
    width: _vm.width,
    height: _vm.height,
  }),on:{"click":function($event){return _vm.handleTabClick(tab[_vm.propsMap.key])}}},[_vm._v(" "+_vm._s(tab[_vm.propsMap.label])+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }